import React from 'react'
// components
import { Box } from '@mui/material'
// icons
import { AsteriskIcon } from 'components/FormElements/components/InputLabel'

interface LabelProps {
  text?: string
  showAsterisk: boolean
}

const DatePickerLabel: React.FC<LabelProps> = ({ text, showAsterisk }) => (
  <Box display='flex' alignItems='center'>
    {showAsterisk && <AsteriskIcon />}
    {text && <span>{text}</span>}
  </Box>
)

export default DatePickerLabel
